import React from "react";
import { SwiperSlide } from "swiper/react";
import Swiper from "@/components/swiper";

import { useTranslationDetector } from "@/hooks/useTranslationDetector";

import { Button } from "@/components/ui/Button";
import PopularRentalCarCard from "./PopularRentalCarCard";

export default function PopularRentalCarsCarousel({
  carList,
  handleClick,
  activeClass,
}) {
  const t = useTranslationDetector();

  return (
    <div className="relative mt-4 w-full md:mt-8">
      <Swiper
        swiperOptions={{
          slidesPerView: 1.1,
          spaceBetween: 12,
          pagination: {
            clickable: true,
            el: ".swiper-popular-cars-pagination",
          },
          navigation: {
            prevEl: `#rental-car-navigation-prev`,
            nextEl: `#rental-car-navigation-next`,
          },
          breakpoints: {
            0: {
              slidesPerView: 1.1,
              spaceBetween: 12,
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          loop: true,
        }}
      >
        {carList.map((car, index) => (
          <SwiperSlide
            key={`popular_car_item_${activeClass}_${index}`}
            className={`w-[284px] pb-1 first:ms-0 lg:!w-[400px]`}
          >
            <PopularRentalCarCard
              index={index}
              car={car}
              handleClick={handleClick}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="mt-4 mb-6 flex justify-center md:mt-6 md:mb-10">
        <Button className="select-none" onClick={handleClick}>
          {t("Car.RentNowHome")}
        </Button>
      </div>

      <div className="swiper-custom-pagination swiper-popular-cars-pagination hidden items-center justify-center gap-2 md:flex" />
    </div>
  );
}
